import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const ACCOUNT_INFORMATION_CONSTANTS = {
  id: 'account',
  title: 'Actualización de Datos',

  labels: {
    ...COMMONS,
    age: 'Edad',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    lastName: 'Apellido',
    born: 'Nacimiento',
    locationBornPlaceholder: 'Lugar de nacimiento...',
    additional: 'Genero / Estado civil',
    contact: 'Contacto',
    emailPlaceholder: 'Correo electrónico...',
    phonePlaceholder: '# de teléfono',
    doctorHeading: 'Datos',
    passwordHeading: 'Contraseña',
    passwordVerify: 'Verificar Contraseña'
  },

  actions: {
    ...ACTIONS,
    new: `${ACTIONS.add} Persona`,
    edit: `${ACTIONS.edit} Persona`,
    updatePass: 'Actualizar Contraseña'
  }
};
